import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import CertificateCards from "./cri-cards";
import HTML from "../../Assets/Certificates/HTML CSS.png";
// import Python from "../../Assets/Certificates/Python.png";
import JS from "../../Assets/Certificates/Java Script.png";

function Certificate() {
  return (
    <Container fluid className="project-section">
      <Container>
        <h1 className="project-heading">
          My <strong className="purple">Certificates </strong>
        </h1>
        <p style={{ color: "white" }}>
          These are the Certificates done by Me.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          {/* <Col md={4} className="project-card">
            <CertificateCards
              imgPath={Python}
              title="Python Certification"
              description="Verified Certificate ID: 9qnM68p6011v1Z607w"
              certificateId="9qnM68p6011v1Z607w"
              CLink="https://www.guvi.in/share-certificate/9qnM68p6011v1Z607w"
            />
          </Col> */}

          <Col md={4} className="project-card">
            <CertificateCards
              imgPath={HTML}
              title="HTML & CSS Certification"
              description="Verified Certificate ID: 0l1L615P97k1Sn953F"
              certificateId="0l1L615P97k1Sn953F"
              CLink="https://www.guvi.in/share-certificate/0l1L615P97k1Sn953F"
            />
          </Col>

          <Col md={4} className="project-card">
          <CertificateCards
              imgPath={JS}
              title="Java Script Certification"
              description="Verified Certificate ID: 7v855Y39525o4d4q11"
              certificateId="9qnM68p6011v1Z607w"
              CLink="https://www.guvi.in/share-certificate/7v855Y39525o4d4q11"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Certificate;
